/* Offres multi-produits (bloc mr-offers-2) — JS déporté en asset pour alléger l'éditeur de thème.
   Reprend le JS de la version live (refonte UX pastille initiale) + init limitée aux blocs
   data-mro-root="v2" et registre window.mroTimersV2. */
(function () {
  'use strict';

  var DESIGN_MODE = !!(window.Shopify && window.Shopify.designMode);

  function startCountdown(root) {
    var el = root.querySelector('[data-mro-countdown]');
    if (!el) return;
    var hours = parseInt(root.getAttribute('data-timer-hours'), 10) || 24;
    var key = 'mro_deadline_' + root.id;
    var hkey = 'mro_hours_' + root.id;
    var storedHours = parseInt(localStorage.getItem(hkey), 10);
    var deadline = parseInt(localStorage.getItem(key), 10);
    var now = Date.now();
    if (!deadline || isNaN(deadline) || deadline <= now || storedHours !== hours) {
      deadline = now + hours * 3600 * 1000;
      try { localStorage.setItem(key, String(deadline)); localStorage.setItem(hkey, String(hours)); } catch (e) {}
    }
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      var diff = deadline - Date.now();
      if (diff <= 0) {
        deadline = Date.now() + hours * 3600 * 1000;
        try { localStorage.setItem(key, String(deadline)); } catch (e) {}
        diff = deadline - Date.now();
      }
      var t = Math.floor(diff / 1000);
      el.textContent = pad(Math.floor(t / 3600)) + ':' + pad(Math.floor((t % 3600) / 60)) + ':' + pad(t % 60);
    }
    tick();
    window.mroTimersV2 = window.mroTimersV2 || {};
    if (window.mroTimersV2[root.id]) clearInterval(window.mroTimersV2[root.id]);
    if (DESIGN_MODE) return;
    window.mroTimersV2[root.id] = setInterval(tick, 1000);
  }

  function buildItems(checked) {
    var items = [];
    var fixed = checked.getAttribute('data-mro-fixed') || '';
    fixed.split(',').forEach(function (pair) {
      if (!pair) return;
      var parts = pair.split(':');
      var id = parseInt(parts[0], 10);
      var qty = parseInt(parts[1], 10) || 1;
      if (id) items.push({ id: id, quantity: qty });
    });
    var wrap = checked.closest('.mro__offer-wrap');

    var groups = wrap ? wrap.querySelectorAll('.mro__variants') : [];
    for (var i = 0; i < groups.length; i++) {
      var qty = parseInt(groups[i].getAttribute('data-mro-vqty'), 10) || 1;
      var sel = groups[i].querySelector('input:checked');
      if (!sel) return { error: 'Cette taille est en rupture de stock. Choisissez-en une autre.' };
      var vid = parseInt(sel.value, 10);
      if (vid) items.push({ id: vid, quantity: qty });
    }

    var persos = wrap ? wrap.querySelectorAll('.mro__perso') : [];
    for (var k = 0; k < persos.length; k++) {
      var pp = persos[k];
      var yes = pp.querySelector('[data-mro-perso-yes]');
      if (yes && yes.checked) {
        var inp = pp.querySelector('[data-mro-perso-input]');
        var val = inp ? inp.value.trim() : '';
        if (!val) return { error: 'Merci de remplir le champ de personnalisation.' };
        var pvid = parseInt(pp.getAttribute('data-mro-perso-vid'), 10);
        var pkey = pp.getAttribute('data-mro-perso-key') || 'Initiale';
        if (pvid) {
          var props = {};
          props[pkey] = val;
          items.push({ id: pvid, quantity: 1, properties: props });
        }
      }
    }

    return items;
  }

  function refreshPrice(wrap) {
    var priceEl = wrap.querySelector('.mro__price');
    if (!priceEl) return;
    if (!priceEl.dataset.mroBase) priceEl.dataset.mroBase = priceEl.textContent.trim();
    var base = priceEl.dataset.mroBase;
    var addCents = 0;
    wrap.querySelectorAll('.mro__perso').forEach(function (pp) {
      var yes = pp.querySelector('[data-mro-perso-yes]');
      var on = !!(yes && yes.checked);
      pp.classList.toggle('is-on', on);
      if (on) addCents += parseInt(pp.getAttribute('data-mro-perso-add'), 10) || 0;
    });
    if (addCents) {
      var num = parseFloat(base.replace(/\s/g, '').replace(/[^0-9,.-]/g, '').replace(',', '.'));
      priceEl.textContent = isNaN(num) ? base : (num + addCents / 100).toFixed(2).replace('.', ',') + ' €';
    } else {
      priceEl.textContent = base;
    }
  }

  function addToCart(root, cta) {
    var checked = root.querySelector('input[name^="mro_offer_"]:checked');
    var items = checked ? buildItems(checked) : [];
    if (items && items.error) { alert(items.error); return; }
    if (!items || !items.length) { alert('Cette offre n\'est pas encore configurée (produit manquant).'); return; }

    var orig = cta.innerHTML;
    cta.disabled = true;
    cta.innerHTML = '<span style="letter-spacing:.1em">Ajout en cours…</span>';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data.status) { cta.disabled = false; cta.innerHTML = orig; alert(data.description || 'Erreur lors de l\'ajout au panier.'); return; }
      cta.innerHTML = '<span style="letter-spacing:.1em">✓ Ajouté !</span>';
      cta.style.background = '#5A7A50';
      if (typeof aovCartDrawerUpdateAndOpen === 'function') aovCartDrawerUpdateAndOpen();
      else if (typeof aovCartDrawerOpen === 'function') aovCartDrawerOpen();
      setTimeout(function () { cta.innerHTML = orig; cta.style.background = ''; cta.disabled = false; }, 2500);
    })
    .catch(function () { cta.disabled = false; cta.innerHTML = orig; alert('Une erreur est survenue. Veuillez réessayer.'); });
  }

  function initRoot(root) {
    if (root.dataset.mroInit) return;
    root.dataset.mroInit = '1';
    startCountdown(root);
    if (!root.querySelector('input[name^="mro_offer_"]:checked')) {
      var first = root.querySelector('input[name^="mro_offer_"]');
      if (first) first.checked = true;
    }
    var cta = root.querySelector('[data-mro-cta]');
    if (cta) cta.addEventListener('click', function () { addToCart(root, cta); });

    root.querySelectorAll('.mro__offer-wrap').forEach(function (wrap) {
      wrap.querySelectorAll('[data-mro-perso-radio]').forEach(function (r) {
        r.addEventListener('change', function () { refreshPrice(wrap); });
      });
      refreshPrice(wrap);
    });
  }

  function init() { document.querySelectorAll('[data-mro-root="v2"]').forEach(initRoot); }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
  if (!window.mroBoundV2) { window.mroBoundV2 = true; document.addEventListener('shopify:section:load', init); }
})();
